<template>
    <span v-if="canRefresh" class="float-right refresh-icon" @click="refresh"><font-awesome-icon icon="sync" v-tooltip="'Kliknij, aby odświeżyć'"/></span>
</template>

<script>
    export default {
        name: 'Refresh',
        data() {
            return {
                canRefresh: false,
            };
        },
        created() {
            setTimeout(this.setCanRefresh, 3000);
        },
        props: {
            func: Function,
        },
        methods: {
            refresh() {
                if (this.canRefresh) {
                    this.func();
                    this.canRefresh = false;
                    setTimeout(this.setCanRefresh, 3000);
                }
            },
            setCanRefresh() {
                this.canRefresh = true;
            },
        }
    }
</script>

<style>
    .refresh-icon {
        cursor: pointer;
        font-size: 1.3rem;
        line-height: 40px;
    }
</style>